const cache = new Map()

export async function getCachedRequest(key, fetchFn) {
  const now = Date.now()
  const entry = await cache.get(key)

  if (entry && entry.expiresAt > now) {
    return entry.data
  }

  if (entry?.promise) {
    return entry.promise
  }

  const promise = (async () => {
    try {
      const data = await fetchFn()
      cache.set(key, {
        data,
        expiresAt: Date.now() + 60_00
      })
      return data
    } catch (error) {
      cache.set(key, {
        data: null,
        expiresAt: Date.now() + 5_000
      })
      throw error
    }
  })()

  cache.set(key, { promise })
  return promise
}
